export const titleFilter = dirtyTitle => {
  const index = dirtyTitle.indexOf('&');
  if (index !== -1) {
    return dirtyTitle.slice(0, index);
  }

  return dirtyTitle;
};
